import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import styles from './style.scss';

const EventbriteMarker = () => (
  <img className={styles.marker} alt="eventbrite marker" src="static/eventbrite_map_icon.png" />
);

function GoogleMap({ latitude, longitude }) {
  const center = { lat: latitude, lng: longitude };
  return (
    <GoogleMapReact
      defaultCenter={center}
      defaultZoom={11}
      bootstrapURLKeys={{ key: 'AIzaSyDNGGckSzq7aDmMCQaddC1R40VsBMLCFtA' }}
    >
      <EventbriteMarker lat={latitude} lng={longitude} />
    </GoogleMapReact>
  );
}

GoogleMap.propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
};
export default GoogleMap;



// WEBPACK FOOTER //
// ./src/widget/event_components/google_map.js